<template>
  <article>
    <section class="section font-roboto">
      <div>
        <h1
          class="mb-8 text-[20px] font-medium leading-[26px] xl:text-[32px] xl:leading-[38px]"
        >
          О ПОРТАЛЕ ИСТОРИЯ.РФ
        </h1>
        <div
          class="mb-2 text-[16px] leading-[24px] xl:text-[18px] xl:leading-[28px]"
        >
          <div class="mb-3">
            Портал История.РФ – уникальный федеральный ресурс, содержащий
            обширную коллекцию материалов для изучения истории России и
            Российской Федерации. Информационные материалы портала представлены
            в разнообразных форматах - видео, аудио, тексты статей и новостной
            дайджест, энциклопедические и исторические словари, оригиналы
            исторических и архивных документов, карты и геоинформационные
            материалы. Все информационные материалы подготовлены экспертами и
            дипломированными специалистами в области истории.
          </div>
          <div class="mb-3">
            Портал История.РФ – идеальное место для изучения истории России как
            для широкой аудитории, интересующейся историей Отечества, так и в
            качестве незаменимого образовательного ресурса для подрастающего
            поколения.
          </div>
          <div class="mb-3">
            Видеолекции, документальные фильмы, инфографика и презентации –
            множество наглядных аудиовизуальных материалов, которые специально
            созданы для подготовки интересных вовлекающих уроков истории и
            обществознания. Для преподавателей образовательных учреждений
            материалы могут служить основой для подготовки урока или источником
            актуальных тем для уроков «О главном».
          </div>
          <div class="mb-3">
            Для учащихся портал История.РФ – кладезь информации для создания
            рефератов и эссе, подготовки к любым тестам и экзаменам. Благодаря
            информации портала История.РФ школьники получают возможность
            отвечать на самые сложные и каверзные вопросы на олимпиадах по
            истории, успешно участвовать в конкурсах и тестах. Этому
            способствуют и специально разработанные тесты к материалам, которые
            позволяют проверить усвоение материала. Все материалы подготовлены в
            соответствии с ФГОС и полностью охватывают учебную программу.
          </div>
          <div class="mb-3">
            С 2024 года История.РФ реализует проект «Учителю и ученику», который
            представляет все материалы сайта в соответствии со структурой новых
            единых учебников по истории. Проект предлагает дополнительные
            материалы к теме каждого параграфа учебника, перейти на которые
            можно через код быстрого отклика (QR). В период, когда Россия
            переходит на преподавание истории в соответствии с единой линейкой
            учебников, проект сайта История.РФ оказывает методическую и
            содержательную поддержку учителям и методистам в их работе, а для
            учеников раскрывает историю России во всем богатстве, сложности и
            многообразии.
          </div>
          <div class="mb-3">
            Такой информационный ресурс, как История.РФ, имеет огромное
            социальное значение и является незаменимым каналом в передаче не
            только знаний, но и чувства глубокого уважения и гордости за свою
            страну. Патриотическое воспитание молодых поколений невозможно без
            знания истории, подвигов предков, жизни и быта людей, которые
            строили и делали великим российское государство.
          </div>
          <div class="mb-3">
            Портал История.РФ - практически единственный достоверный источник
            такого масштаба, рассказывающий о событиях, происходящих в истории
            России и тех мировых событиях, в которых Россия была
            непосредственным участником.
          </div>
          <div class="mx-auto mb-4 mt-6 w-fit font-bold">
            История и статистика сайта
          </div>
          <div class="mb-3">
            Сайт История.РФ был создан в 2012 году. В 2025 году информационной
            платформе исполняется 13 лет.
          </div>
          <div class="mb-3">
            Каждый год сайт прирастает более, чем 7-ю миллионами новых
            (уникальных) пользователей. Среднее годовое количество посещений за
            последние 3 года составило 15 миллионов визитов. При среднем
            показателе глубины просмотров не менее 2,5, количество просмотров в
            год составляет не менее 30 миллионов. К примеру, показатель
            просмотров в 2022 году, согласно статистике в сервисе Яндекс.Метрика
            составил 34 миллиона.
          </div>
          <div class="mb-3">
            С развитием новых информационных каналов, активном использовании
            пользователями сети Интернет мессенджера Телеграмм, социальной сети
            ВКонтакте, контент-платформ Яндекс.Дзен и видео-хостингов, сайт
            История.РФ приобрел новые источники переходов на платформу. В 2022
            году количество переходов из мессенджера Телеграмм составило 25
            тысяч и с тех пор количество только растет.
          </div>
          <div class="mb-3">
            Сайт История.РФ представлен во всех самых популярных каналах и
            активно развивает свои группы в ВКонтакте, в Телеграмм, в
            Яндекс.Дзен, на каналах видеохостингов.
          </div>
          <div class="mb-6">
            Платформа История.РФ оснащена приложением для мобильных устройств, в
            котором пользователи могут найти всю информацию сайта,
            классифицированную по формам подачи (аудио, видео, для чтения).
            Аудио материалы можно прослушивать в фоновом режиме.
          </div>
          <img
            v-lazy-load
            src="/imgs/about-1.png"
            alt="stat"
            class="mx-auto w-2/3"
          />

          <div class="mx-auto mb-4 mt-6 w-fit text-center font-bold">
            ПРОЕКТ <br />«ИСТОРИЯ.РФ – УЧИТЕЛЮ И УЧЕНИКУ»
          </div>
          <div class="mb-3">
            Главный исторический портал страны История.РФ предлагает уникальную
            ресурсную базу экспертных материалов в качестве источника
            дополнительной информации для преподавателей Истории России и
            Всеобщей истории в российских образовательных учреждениях, а также
            учащихся – для более глубокого изучения истории – проект «Учителю и
            ученику».
          </div>
          <div class="mb-3">
            Все представленные дополнительные материалы удобно разделены по
            главам и параграфам новых учебников по предмету История России и
            Всеобщая история.
          </div>
          <div class="mb-3">
            Информационные материалы представлены как в стандартных форматах –
            статей, тестов, аудио- и видео контента, так и в новых форматах –
            наборов иллюстраций, карт, архивных документов. Всего более 20 тысяч
            материалов представлено к сентябрю 2024 года и ежемесячно их база
            пополняется. Все материалы подготовлены в соответствии с ФГОС и
            полностью охватывают учебную программу по истории.
          </div>
          <div class="mb-3">
            Тестирование проекта завершено до начала нового учебного года
            2024-2025 года и учебный год стартовал с новыми возможностями в
            изучении истории в российских школах и учреждениях среднего
            специального образования.
          </div>
          <div class="mb-3">
            Проект «Учителю и ученику» – это современная технология преподавания
            истории в школе, инновация, которая в будущем преобразуется в
            практически применяемый учителем стандарт.
          </div>
          <div class="mb-3">
            Созданный на базе исторического портала История.РФ электронный
            сервис содержит информационные материалы, позволяющие создать
            программу урока, тематическое планирование, подготовить наглядный и
            раздаточный материал, эффективно и, главное, интересно, рассказать
            об изучаемых событиях. Ученики смогут погрузиться в тему, изучая
            оригинальные исторические документы и провести собственные научные
            исследования.
          </div>
          <div class="mb-3">
            Отдельным разделом проекта является направление изучения всей
            территории нашей Родины. В специальных материалах раздела «Пункт
            назначения – Россия» содержатся авторские статьи, повествующие об
            уникальных историях и удивительной истории, географии, культуре
            каждого субъекта Российской Федерации.
          </div>
          <div class="mb-3">
            «Пункт назначения — Россия» позволяет совместить туризм и
            историческое просвещение как внутри региона, так и в путешествиях по
            родной стране. Материалы предназначены для групповой работы под
            руководством и по инициативе педагога-предметника, так и для
            индивидуальных познавательных туров. Раздел разработан Российским
            военно-историческим обществом и Агентством развития внутреннего
            туризма, также в раздел включены образовательные программы
            путешествий и детские творческие проекты — Азбуки символов регионов,
            разработанные региональными проектными командами и школьными
            командами в рамках реализации Международной программы «Классная
            страна», реализуемой Агентством стратегических инициатив при
            поддержке Минпросвещения России, Минэкономразвития России и АНО
            «Национальные приоритеты».
          </div>
          <div class="mb-3">
            Электронный ресурс «Учителю и ученику» поможет как учителю истории,
            так и учащимся максимально глубоко вовлечься в процесс познания,
            испытать искренний интерес к изучению истории через дополнительные
            материалы и чувствовать гордость за страну и её историческое
            прошлое.
          </div>
          <div class="mb-3">
            Портал История.РФ предоставляет достоверный информационный материал,
            созданный экспертами научно-исторического сообщества с учетом
            современного исторического пространства и идеологии. Партнерами
            проекта, предоставившими свои материалы, являются Министерство
            Просвещения Российской Федерации, Российское историческое общество,
            Российское общество Знание, Агентство стратегических инициатив,
            Высшая школа экономики, Институт развития интернета, проект
            Россия-моя история и другие.
          </div>
          <div class="mb-6">
            Информационный цифровой проект «Учителю и ученику» незаменим в
            подготовке к ВПР, ОГЭ, ЕГЭ, для саморазвития, а также для
            профессионального развития современного российского учителя истории.
          </div>
          <div>
            <img
              v-lazy-load
              src="/imgs/about-2.png"
              alt="stat"
              class="mx-auto w-2/3"
            />
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script setup>
useHead({
  title: 'Информация о Федеральном портале Истории России',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Авторы Федерального портала Истории России – профессиональные историки.',
    },
  ],
});
</script>
